import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamRestartCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamRestartCmd.validationSchema()
  );

  constructor(readonly value: RoomStreamRestartCmdRaw) {
    JsonSchemaValidator.assert(RoomStreamRestartCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      },
      additionalProperties: false
    };
  }
}

interface RoomStreamRestartCmdRaw {
  roomId: RoomId;
  streamId: StreamId;
}
